const state = () => ({})

const getters = {}

const mutations = {}

const actions = {}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
